module.exports = __webpack_public_path__ + "static/img/bottom_top.e0726b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/product/bottom_top.png
// module id = 191A
// module chunks = 1